import { createStore } from 'vuex'

export default createStore({
    state() {
        const user = localStorage.getItem('user')
        const authorization = localStorage.getItem('authorization')
        return {
            spread: sessionStorage.getItem('spread'),
            identity: localStorage.getItem('identity'),
            referrerUid: sessionStorage.getItem('referrerUid'),
            user: user && user !== 'undefined' ? JSON.parse(user) : {},
            authorization: authorization ? authorization : '',
            authorizationTime: localStorage.getItem('authorizationTime') ? localStorage.getItem('authorizationTime') : 0
        }
    },
    mutations: {
        initIdentity(state) {
            let identity = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                let r = Math.random() * 16|0, v = c == 'x' ? r : (r&0x3|0x8);
                return v.toString(16);
            });
            state.identity = identity;
            localStorage.setItem('identity', identity);
        },
        setSpread(state, data) {
            state.spread = data;
            sessionStorage.setItem('spread', data);
        },
        setReferrerUid(state, data) {
            state.referrerUid = data;
            sessionStorage.setItem('referrerUid', data);
        },
        setUser(state, data) {
            state.user = data;
            localStorage.setItem('user', JSON.stringify(data));
        },
        setAuthorization(state, token) {
            state.authorization = token;
            state.authorizationTime = token ? new Date().getTime() + 86400000 : 0;
            localStorage.setItem('authorization', token);
            localStorage.setItem('authorizationTime', state.authorizationTime);
        }
    }
});